var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "reference-sidesheet",
    {
      ref: "modal",
      attrs: {
        "sidesheet-header": _vm.id
          ? "Редактирование типа документа"
          : "Новый тип документа",
        "display-actions": !!_vm.id,
      },
      on: { onSubmit: _vm.onSubmit, onReset: _vm.onReset },
      scopedSlots: _vm._u([
        {
          key: "sidesheet-actions",
          fn: function () {
            return [
              _vm.id && _vm.savedData.docs
                ? _c(
                    "div",
                    { staticClass: "layout-header-action" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "documents-group__remove",
                          attrs: { id: "doctype-remove-wrapper-sidesheet" },
                        },
                        [
                          _c("c-button-2", {
                            attrs: {
                              size: "small",
                              label: "Удалить",
                              disabled: _vm.savedData.docs.length > 0,
                              icon: {
                                icon: "trash",
                                color: "secondary",
                              },
                            },
                            on: { click: _vm.deleteDocumentType },
                          }),
                        ],
                        1
                      ),
                      _vm.savedData.docs.length > 0
                        ? _c(
                            "b-popover",
                            {
                              attrs: {
                                placement: "top",
                                triggers: "hover blur",
                                target: "doctype-remove-wrapper-sidesheet",
                              },
                            },
                            [
                              _c("error-feedback", {
                                staticClass: "m-0 empty-category-tooltip",
                                attrs: {
                                  text: "В данный момент удаление невозможно, так как тип содержит документы. Сначала перенесите все документы из типа.",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("u-confirm", { ref: "confirm", attrs: { id: "delete-doctype" } }),
      _c("div", { staticClass: "doctype-form" }, [
        _c(
          "div",
          {
            staticClass: "doctype-form__name",
            style: {
              "margin-bottom": _vm.submitted && _vm.nameError ? "60px" : "40px",
            },
          },
          [
            _c("c-input-2", {
              attrs: {
                "floating-label": "Наименование документа",
                required: _vm.submitted && _vm.nameError,
                "required-message": _vm.submitted && _vm.nameError,
                "required-mark": true,
                "max-length": 500,
                clearable: true,
              },
              model: {
                value: _vm.form.name,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "name", $$v)
                },
                expression: "form.name",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "doctype-form__description" },
          [
            _c("c-textarea", {
              ref: "description",
              attrs: {
                "floating-label": "Описание",
                type: "textarea",
                "max-length": 500,
                clearable: true,
              },
              model: {
                value: _vm.form.description,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "description", $$v)
                },
                expression: "form.description",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "doctype-form-issues" }, [
        _c("h2", [_vm._v("Проблемы с документами")]),
        _c("div", { staticClass: "doctype-form-issues__colors" }, [
          _c(
            "div",
            { staticClass: "doctype-form-issues__color" },
            [
              _c("document-color", {
                ref: "absentColor",
                attrs: {
                  validate: _vm.submitted,
                  label: "Цвет отсутствующего документа",
                  "default-color": "#FF0000",
                },
                model: {
                  value: _vm.form.absentColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "absentColor", $$v)
                  },
                  expression: "form.absentColor",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "doctype-form-issues__color" },
            [
              _c("document-color", {
                ref: "expiredColor",
                attrs: {
                  validate: _vm.submitted,
                  label: "Цвет истекшего срока годности",
                  "default-color": "#FF238D",
                },
                model: {
                  value: _vm.form.expiredColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "expiredColor", $$v)
                  },
                  expression: "form.expiredColor",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "doctype-form-issues__color" },
            [
              _c("document-color", {
                ref: "expiringColor",
                attrs: {
                  validate: _vm.submitted,
                  label: "Цвет истекающего срока годности",
                  "default-color": "#FFB800",
                },
                model: {
                  value: _vm.form.expiringColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "expiringColor", $$v)
                  },
                  expression: "form.expiringColor",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }